import { Pipe, PipeTransform } from '@angular/core';
import { TimesheetEntryColors, TimesheetEntryType } from '../store/application';
import * as HelperFunctions from '../../assets/helper-functions/helper-functions';

@Pipe({
  name: 'exceptionTypeColours'
})
export class ExceptionTypeColoursPipe implements PipeTransform {

  transform(exceptionTypeId: number): string {

    var exceptionType: TimesheetEntryType = HelperFunctions.getExceptionFromTypeId(exceptionTypeId);

    switch (exceptionType) {
      case TimesheetEntryType.REGULAR_DAY: return TimesheetEntryColors.REGULAR_DAY;
      case TimesheetEntryType.OVERTIME: return TimesheetEntryColors.OVERTIME;
      case TimesheetEntryType.VACATION: return TimesheetEntryColors.VACATION;
      case TimesheetEntryType.SICK: return TimesheetEntryColors.SICK;
      case TimesheetEntryType.STAT: return TimesheetEntryColors.STAT;
      case TimesheetEntryType.OTHER: return TimesheetEntryColors.OTHER;
      case TimesheetEntryType.CDO: return TimesheetEntryColors.CDO;
      default: return TimesheetEntryColors.OTHER;
  }
  }
}
